import { formatNumberExactDecimals } from "@icarius-utils/format";
import { getLocalizedString } from "@icarius-localization/strings";

export function onFocusedCellChanged(e) {
    if (e.cellElement[0].id.includes("Cantidad")) {
        const nodeId = e.cellElement[0].id.replace("Cantidad", "Horas y Minutos (hh:mm)");
        const node = document.getElementById(nodeId);
        if (node?.value) {
            const { value } = node;
            let arr = value.split(':');
            let dec = parseInt((arr[1] / 6) * 10, 10);
            let newValue = parseFloat(parseInt(arr[0], 10) + '.' + (dec < 10 ? '0' : '') + dec);
            newValue = formatNumberExactDecimals(newValue, 3);
            const rowsQuantity = e.component.getVisibleRows().length;
            for (let i = 0; i < rowsQuantity; i++) {
                const rows = e.component.getRowElement(i);
                if (rows[0].className.includes("dx-datagrid-edit-form")) {
                    window.setTimeout(function () {
                        e.component.cellValue(i, "Cantidad", newValue);
                    }, 100);
                }
            }
        }
    }
}

export function onEditorPrepared(options, selectDataSources) {
    if (options.dataField === "Concepto") {
        const htmlElement = document.getElementById(options.id);
        const arrElem = selectDataSources("all-concepts");
        const foundElement = arrElem.find(el => el.key === options.value)
        if (htmlElement && foundElement) {
            htmlElement.addEventListener('mousemove', function () {
                htmlElement.setAttribute('title', foundElement.comment);
            });
        }
    }
}

export function onEditorPreparing(options, selectDataSources, getUnAuthData, getHHMMforMinutes, getMinutesForHHMM, compareData) {
    const MONTHS = [
        getLocalizedString("january"),
        getLocalizedString("february"),
        getLocalizedString("march"),
        getLocalizedString("april"),
        getLocalizedString("may"),
        getLocalizedString("june"),
        getLocalizedString("july"),
        getLocalizedString("august"),
        getLocalizedString("september"),
        getLocalizedString("october"),
        getLocalizedString("november"),
        getLocalizedString("december"),
    ];

    if (options.dataField === "En fecha" && options.value === undefined) {
        options.editorOptions.value = new Date();
        options.setValue(options.editorOptions.value)
    }

    if (MONTHS.includes(options.dataField) && options.value === undefined) {
        // Pongo por defecto el valor N
        options.editorOptions.value = "N";
        options.setValue(options.editorOptions.value)
    }

    if (options.dataField === "periodicity" && options.value === undefined) {
        // Pongo por defecto el valor F
        options.editorOptions.value = "F";
        options.setValue(options.editorOptions.value)
    }

    if (options.dataField === "code" && options.value !== undefined) {
        options.editorOptions.disabled = true;
    }

    if (options.dataField === "rate" && options.value !== undefined) {
        options.editorOptions.disabled = true;
    }

    if ([
        "Centro de costo", "Centro de costo 2", "Centro de costo 3", "Centro de costo 4", "Centro de costo 5",
        "Dimensión 2", "Dimensión 3", "Dimensión 4", "Dimensión 5"
    ].includes(options.dataField)) {
        const selectValues = selectDataSources(options.dataField);
        if (selectValues.length === 0) {
            options.editorOptions.disabled = true;
        }
    }

    if (options.dataField === "Concepto") {
        const { rowIndex } = options.row;
        const instance = options.component;
        const seccalValues = selectDataSources("Secuencia de Cálculo");
        const conceptValues = selectDataSources("all-concepts");

        let onValueChanged = options.editorOptions.onValueChanged;

        options.editorOptions.onValueChanged = function (e) {
            onValueChanged.call(this, e);
            compareData();

            const conceptElement = conceptValues.find(el => el.key === e.value);
            if (conceptElement && conceptElement.value) {
                // Voy a setear el nombre de concepto porque cambie el valor del select
                window.setTimeout(function () {
                    instance.cellValue(rowIndex, "Nombre del concepto", conceptElement.value);
                }, 100);
            }


            if (seccalValues && seccalValues.length > 0) {
                const element = seccalValues.find(el => el.key === e.value);
                if (element) {
                    // También aca voy a setear la seciuencia de calculo
                    window.setTimeout(function () {
                        instance.cellValue(rowIndex, "Secuencia de Cálculo", element.key);
                    }, 100);
                }
            }
        }

    }

    if (options.dataField === "Hrs Extras Autorizadas") {
        const { rowIndex } = options.row;
        const instance = options.component;
        let onValueChanged = options.editorOptions.onValueChanged;

        options.editorOptions.onValueChanged = function (e) {
            onValueChanged.call(this, e);
            compareData();

            // Voy a setear el nombre de concepto porque cambie el valor del select
            window.setTimeout(function () {
                const hoursDone = options.row.data["Hrs Extras Realizadas"];
                const authHours = options.row.data["Hrs Extras Autorizadas"];
                let unAuthHours = "00:00";
                if (hoursDone && hoursDone !== "0:00" && hoursDone !== "00:00" && getHHMMforMinutes && getMinutesForHHMM) {
                    // Paso a minutos el tiempo autorizado
                    const minutesAuthHours = getMinutesForHHMM(authHours);

                    // Paso a minutos el tiempo a autorizar
                    const minutesDoneHours = getMinutesForHHMM(hoursDone);

                    // Obtengo la diferencia de minutos
                    const minutesAuthDifference = minutesDoneHours - minutesAuthHours;

                    // Vuelvo a pasarlo a hh:mm
                    if (!minutesAuthHours) {
                        unAuthHours = getHHMMforMinutes(minutesDoneHours);
                    } else if (minutesAuthDifference <= 0) {
                        unAuthHours = "00:00";
                    } else {
                        unAuthHours = getHHMMforMinutes(minutesAuthDifference);
                    }
                }

                instance.cellValue(rowIndex, "Hrs Extras Sin Autorizar", unAuthHours);
            }, 100);
        }
    }

    if (options.dataField === "Fecha") {
        const { rowIndex } = options.row;
        const instance = options.component;
        let onValueChanged = options.editorOptions.onValueChanged;

        options.editorOptions.onValueChanged = function (e) {
            onValueChanged.call(this, e);
            compareData();

            // Voy a setear el nombre de concepto porque cambie el valor del select
            window.setTimeout(function () {
                const date = options.row.data["Fecha"];
                const employeeCode = options.row.data["Código de empleado"];
                let unAuthElement = null;
                if (getUnAuthData && date && employeeCode) {
                    unAuthElement = getUnAuthData(date, employeeCode);
                }

                let unAuthHours = "00:00";
                if (unAuthElement) {
                    unAuthHours = unAuthElement.hhmm;
                }

                instance.cellValue(rowIndex, "Hrs Extras Realizadas", unAuthHours);
                instance.cellValue(rowIndex, "Hrs Extras Sin Autorizar", unAuthHours);
            }, 100);
        }
    }

    if (options.dataField === "Indicador de cálculo" && options.value !== undefined && options.validationRules.some(el => el.type === "required")) {
        const values = selectDataSources("Indicador de cálculo");
        if (values && values.length === 1) {
            // Pongo por defecto el valor
            options.editorOptions.value = values[0].key;
            options.setValue(options.editorOptions.value)
        }
    }

    if (options.dataField === "Código de referencia" && options.value !== undefined && options.validationRules.some(el => el.type === "required")) {
        const values = selectDataSources("Código de referencia");
        if (values && values.length === 1) {
            // Pongo por defecto el valor
            options.editorOptions.value = values[0].key;
            options.setValue(options.editorOptions.value)
        }
    }

    if (options.parentType === 'dataRow' && options.dataField === 'Concepto') {
        const test = Number(options.row.data["Tipo de concepto"]);
        options.editorOptions.disabled = isNaN(test) || test === 0;
    }

    if (options.dataField === 'Banco' || options.dataField === "Cuenta bancaria") {
        const paymentTypeIsDeposit = options.row.data["Forma de pago"] === "D";
        if (selectDataSources && paymentTypeIsDeposit) {
            const paymentTypes = selectDataSources("Forma de pago");
            const element = paymentTypes.find(el => el.key === "D");

            if (element && element.requiresBank === "Y") {
                options.editorOptions.disabled = false;
            }
        } else {
            options.editorOptions.disabled = true;
        }
    }

    if (options.parentType === 'dataRow' && options.dataField) {
        const data = options.row.data[options.dataField];
        const isRequired = options.validationRules?.some(el => el.type === "required");
        if (isRequired && (data === "" || data === undefined) && options.setValue) {
            setTimeout(() => options.setValue(null))
        }
    }

    if (
        options.dataField !== "Hrs Extras Autorizadas" &&
        options.dataField !== "Fecha" &&
        options.dataField !== "Concepto"
    ) {

        let onValueChanged = options.editorOptions.onValueChanged;
        options.editorOptions.onValueChanged = function (e) {
            onValueChanged.call(this, e);
            compareData();
        }
    }
}

export function onToolbarpreparing(e) {
    let toolbarItems = e.toolbarOptions.items;
    toolbarItems.forEach(function (item) {
        item.options = {
            visible: false
        }
    });
}
